import { IoMdClose } from "react-icons/io";

interface Props {
  className?: string;
  titleClassName?: string;
  titleWords: { text: string; isHighlighted?: boolean }[];
  description: string;
  onClose?: () => void;
}
const EggsFightingHeader = ({
  className = "",
  titleWords,
  description,
  titleClassName = "",
  onClose,
}: Props) => {
  return (
    <div className={`flex items-center justify-between ${className}`}>
      <div>
        <h1
          className={`uppercase text-[2.35rem] flex items-center flex-wrap text-wrap gap-2 leading-[1] ${titleClassName}`}
        >
          {titleWords?.map((word, i) => (
            <span
              key={i}
              className={`${
                word.isHighlighted
                  ? "there-brat-font text-[#1A8BF7] [text-shadow:_0_6px_3px_rgba(26,139,247,0.25)]"
                  : "sporty-pro-font bg-clip-text text-transparent bg-gradient-to-r from-white to-white/50"
              }`}
            >
              {word.text}
            </span>
          ))}
        </h1>
        <p className="inter-font text-white text-[0.8rem] max-w-[320px] text-white/50 leading-[1.1]">
          {description}
        </p>
      </div>

      <button
        title="On close"
        className="bg-white/5 rounded-sm transition hover:opacity-80 active:scale-90 p-2"
        onClick={onClose}
      >
        <IoMdClose size={18} className="text-white/50" />
      </button>
    </div>
  );
};

export default EggsFightingHeader;
